// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const MY_PHONE_REGEX = /^\+60\s?01\d{8,9}$/;

export function validateMalaysianPhone(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim()) {
    return { id: 'empty' };
  }

  if (!MY_PHONE_REGEX.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}
